/* ==========================================================================
   Noveliya — Swatch hover hint
   Swatches are <a> navigation links, one per sibling colour product.
   On mouseenter the hint shows that sibling's colour name (data-value).
   On mouseleave the hint reverts to the active product's colour name.
   ========================================================================== */

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.nv-option').forEach((option) => {
    const container = option.querySelector('.nv-option__swatches');
    const hint      = option.querySelector('[data-swatch-hint]');
    const swatches  = [...(container?.querySelectorAll('.nv-swatch') ?? [])];
    if (!hint || !swatches.length) return;

    const getActiveLabel = () => {
      const active = container.querySelector('.nv-swatch--active');
      return active?.dataset.value ?? '';
    };

    swatches.forEach((swatch) => {
      swatch.addEventListener('mouseenter', () => {
        hint.textContent = swatch.dataset.value ?? '';
      });
    });

    container.addEventListener('mouseleave', () => {
      hint.textContent = getActiveLabel();
    });
  });
});
